<template>
  <div class="rsvp-box">
    <div class="filter-box">
      <div class="date-input">
        <datepicker :format="calendarFormat" v-model="start"
          :class="['datepicker inline', {'has-error':!!validation.start}]"
        ></datepicker>
        <span class="error-msg">{{validation.start}}</span>
      </div>
      <div class="date-input">
        <datepicker :format="calendarFormat"  v-model="end"
          :class="['datepicker inline', {'has-error':!!validation.end}]"
        ></datepicker>
      </div>
      <button @click="getRsvpList" class="button cta small" >
        Submit
      </button>
    </div>

    <div class="card-box summary d-flex align-stretch">
      <div class="data d-flex flex-column justify-space-between">
        <label>All</label>
        <b>{{ summary.all }}</b>
      </div>
      <div class="data d-flex flex-column justify-space-between grayed">
        <label>Card</label>
        <b>{{ summary.card }}</b>
      </div>
      <div class="data d-flex flex-column justify-space-between grayed">
        <label>Not Canceled</label>
        <b>{{ summary.notCanceled }}</b>
      </div>
    </div>

    <div class="card-box summary d-flex align-stretch">
      <div class="data d-flex flex-column justify-space-between">
        <label>Auth</label>
        <b>{{ stats.auth }}</b>
      </div>
      <div class="data d-flex flex-column justify-space-between charged">
        <label>Charged</label>
        <b>{{ stats.charged }}</b>
      </div>
      <div class="data d-flex flex-column justify-space-between no-show">
        <label>No Show</label>
        <b>{{ stats.noshow }}</b>
      </div>
      <div class="data d-flex flex-column justify-space-between canceled">
        <label>Canceled</label>
        <b>{{ stats.canceled }}</b>
      </div>
      <div class="data d-flex flex-column justify-space-between failed">
        <label>Failed</label>
        <b>{{ stats.failed }}</b>
      </div>
    </div>

    <table class="table-box" cellspacing="0">
      <thead>
        <th>Brand</th>
        <th>Service</th>
        <th>Count</th>
      </thead>
      <tbody>
        <tr v-if="list && !list.length">
          <td colspan="3" class="empty">No record found.</td>
        </tr>
        <tr v-for="dat in list">
          <td>{{ dat.brand }}</td>
          <td>{{ dat.service }}</td>
          <td>{{ dat.count }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
/* global CONFIG */
import moment from 'moment'
import datepicker from 'vuejs-datepicker'
import ApiBrands from '@/modules/api/brands'

export default {
  name: 'rsvp',
  components: { datepicker },
  data () {
    return {
      triggerOnLoad: false,
      start: '',
      end: '',
      validation: {
        start: '',
        end: ''
      },
      list: [],
      stats: {
        auth: 0,
        canceled: 0,
        charged: 0,
        failed: 0,
        noshow: 0
      },
      summary: {
        all: 0,
        card: 0,
        notCanceled: 0
      }
    }
  },
  computed: {
    brands () { return this.$store.state.brands.list }
  },
  methods: {
    checkLoaded () {
      if (!this.triggerOnLoad) {
        this.triggerOnLoad = true
        this.getRsvpList()
      }
    },
    calendarFormat (date) { return moment(date).format('MM/DD/YYYY') },
    getRsvpList () {
      let self = this

      let start = moment(self.start, 'MM/DD/YYYY').set('hour', 0).set('minute', 0)
      let end = moment(self.end, 'MM/DD/YYYY').set('hour', 23).set('minute', 59)
      self.validation.start = ''
      if (end.diff(start, 'days') < 0) {
        self.validation.start = 'Cannot be greater than end date.'
        return
      }

      if (!self.brands.length) {
        self.getBrands()
        return
      }

      self.$store.commit('global/setLoaderData', {show: true})
      self.$sdk.get('/utils/listrsvp', {
        start: start.format('YYYY-MM-DD'),
        end: end.format('YYYY-MM-DD')
      }, r => {
        self.$store.commit('global/setLoaderData', {show: false})
        self.list = []
        if (r.error) {
          self.$store.commit('global/setAlertData', {
            show: true,
            message: r.error.message
          })
          return
        }
        if (r.brands) {
          for (var key in r.brands) {
            for (var key2 in r.brands[key]) {
              self.list.push({
                brand: self.getBrandName(key),
                service: r.brands[key][key2].name,
                count: r.brands[key][key2].count
              })
            }
          }
        }
        if (r.statuses) {
          self.stats = {
            auth: r.statuses.AUTH,
            canceled: r.statuses.CANCELED,
            charged: r.statuses.CHARGE,
            failed: r.statuses.FAILED,
            noshow: r.statuses.NOSHOW
          }
        }
        if (r.summary) {
          self.summary = {
            all: r.summary.all,
            card: r.summary.card,
            notCanceled: r.summary.notCanceled
          }
        }
      }, '')
    },
    getBrands () {
      let self = this
      self.$store.commit('global/setLoaderData', {show: true})
      ApiBrands.getBrands(self, r => {
        if (r.error) {
          self.$store.commit('global/setAlertData', {
            show: true,
            message: r.error.message
          })
          self.$store.commit('global/setLoaderData', {show: false})
          return
        }
        self.getRsvpList()
      })
    },
    getBrandName (x) {
      let brand = this.brands.find(b => b.id == x)
      return brand.name
    }
  },
  mounted () {
    this.start = moment().format('MM/DD/YYYY')
    this.end = moment().format('MM/DD/YYYY')
  }
}
</script>

<style lang="scss" scoped>
.rsvp-box{
  padding: 15px;
}

.filter-box{
  display: flex;
  width: 100%;
  border: 1px solid #ccc;
  background: #fafafa;
  padding: 15px;
  border-radius: 4px;
  margin-bottom: 15px;
  align-items: start!important;
  
  .error-msg{
    font-size: 13px;
    color: #f00;
  }
  .button{
    line-height: 20px;
    padding: 10px 20px;
  }
}
.datepicker{
  margin-right: 10px;
}

.card-box{
  border: 1px solid #ccc;
  background: #fff;
  border-radius: 4px;
  gap: 10px;
  padding: 10px;
  width: fit-content;
  margin-bottom: 10px;

  .data{
    padding: 10px;
    background: #fafafa;
    border: 1px solid #eee;
    border-radius: 2px;
    width: 120px;

    &.grayed{
      background: #f2f2f2;
    }
    label{
      display: block;
      line-height: 1;
      letter-spacing: .5px;
      margin-bottom: 10px;
      color: #777;
      font-size: 15px;
      font-weight: 600;
    }
    b{
      font-size: 32px;
      line-height: 1;
    }
    &.charged{
      background: #e0ffd6;
      color: #338509;
      border-color: #338509;
      label{
        color: #338509;
      }
    }
    &.no-show{
      background: #ffe9c1;
      color: #d37f02;
      border-color: #d37f02;
      label{
        color: #d37f02;
      }
    }
    &.canceled{
      background: #ffd1d1;
      color: #b30202;
      border-color: #b30202;
      label{
        color: #b30202;
      }
    }
    &.failed{
      background: #b3b3b3;
      border-color: #333;
      label{
        color: #333;
      }
    }
  }
}

.table-box{
  margin-top: 30px;
  width: 100%;
  border: 1px solid #333;
  background: #fafafa;
  border-radius: 4px;
  overflow: hidden;

  th{
    border-bottom: 1px solid #ddd;
    padding: 5px;
    background: #333;
    color: #fff;
  }
  tr{
    text-align: center;
  }
  td{
    font-size: 14px;
    padding: 7px;
  }
  tr:nth-child(odd) td{
    background: #f3f3f3;
  }
  .empty{
    padding: 30px;
    font-weight: 600;
    font-size: 28px;
    color: #777;
  }

}

@media only screen and (max-width: 430px){
  .filter-box {
    display: flex;
    flex-wrap: wrap;

    .date-input {
      width: 50%;

      
      &:nth-of-type(2) {
        .datepicker {
          margin: 0;
        }
        /deep/ .vdp-datepicker__calendar {
          right: 0;
        }
      }

    }

    .button {
      width: 100%;
      margin-top: 10px;
    }
  }

  .card-box {
    width: 100%;

    &:nth-of-type(3) {
      flex-wrap: wrap;
      .data {
        width: 100px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AdminCode/rsvp.vue